import styled from 'styled-components'

export const StyledDescription = styled.div`
    span {
        font-weight: 700;
    }
`
